module.exports = __webpack_public_path__ + "img/artnhealing_option_05.39916897.jpg";